import {
  GenerateAgenticLogicRuleScenariosMemberRequestType,
  GenerateAgenticLogicRuleScenariosResponseType,
} from "@intelligems/ig-types/functions/agentic-logic/generate-scenarios/generate-scenarios";
import { aiApiClient } from "@src/api/ai-api";
import { useMutation } from "@tanstack/react-query";

/**
 * Direct call to the ai service's member scenario generation — the
 * interactive lane. The caller persists the returned set through save-draft
 * (merged with authored scenarios), which is what flips the scenarios GET
 * from "pending" to "ready".
 */
const generateAgenticLogicScenarios = async (
  body: GenerateAgenticLogicRuleScenariosMemberRequestType
) => {
  const resp =
    await aiApiClient.post<GenerateAgenticLogicRuleScenariosResponseType>(
      "/agentic-logic-scenarios/generate-for-rule",
      body,
      { timeout: 180_000 }
    );
  return resp.data;
};

export const useGenerateAgenticLogicScenarios = () => {
  return useMutation<
    GenerateAgenticLogicRuleScenariosResponseType,
    Error,
    GenerateAgenticLogicRuleScenariosMemberRequestType
  >({ mutationFn: generateAgenticLogicScenarios });
};
